export const ROUTES = {
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
  },
  LEGAL: {
    TERMS: '/terms-of-service',
    PRIVACY: '/privacy-policy',
  },
  HOME: '/',
  DASHBOARD: '/dashboard',
  TRADES: {
    LIST: '/trades',
    DETAIL: '/trades/:id',
    CREATE: '/trades/new',
    EDIT: '/trades/:id/edit',
    IMPORT: '/trades/import',
  },
  EMOTIONS: {
    LIST: '/emotions',
    CREATE: '/emotions/new',
    ANALYSIS: '/emotions/analysis',
    CALENDAR: '/emotions/calendar',
  },
  CHECKLIST: {
    PRE_TRADE: '/checklist/pre-trade',
    RESULT: '/checklist/result/:id',
    HISTORY: '/checklist/history',
  },
  COOLDOWN: '/cooldown',
  REPORTS: {
    WEEKLY: '/reports/weekly',
    MONTHLY: '/reports/monthly',
    CUSTOM: '/reports/custom',
  },
  PROFILE: '/profile',
  SETTINGS: '/settings',
  SUBSCRIPTION: '/subscription',
} as const;

export const MOBILE_SCREENS = {
  AUTH: {
    LOGIN: 'Login',
    REGISTER: 'Register',
    FORGOT_PASSWORD: 'ForgotPassword',
  },
  LEGAL: {
    TERMS: 'TermsOfService',
    PRIVACY: 'PrivacyPolicy',
  },
  MAIN: 'Main',
  TABS: {
    HOME: 'HomeTab',
    TRADES: 'TradesTab',
    EMOTION: 'EmotionTab',
    CHECKLIST: 'ChecklistTab',
    PROFILE: 'ProfileTab',
  },
  HOME: {
    DASHBOARD: 'Dashboard',
  },
  TRADES: {
    LIST: 'TradeList',
    DETAIL: 'TradeDetail',
    FORM: 'TradeForm',
    IMPORT: 'ImportTrades',
  },
  EMOTIONS: {
    LOG: 'EmotionLog',
    FORM: 'EmotionForm',
    ANALYSIS: 'EmotionAnalysis',
  },
  CHECKLIST: {
    PRE_TRADE: 'PreTradeChecklist',
    RESULT: 'ChecklistResult',
    COOLDOWN: 'Cooldown',
  },
  PROFILE: {
    MAIN: 'Profile',
    REPORTS: 'Reports',
    SETTINGS: 'Settings',
    SUBSCRIPTION: 'Subscription',
  },
} as const;
